import { FC, useState } from 'react';
import PayoutPaymentHistory from './PayoutPaymentHistory';
import PayoutPaymentMethod from './PayoutPaymentMethod';
import { LABEL_CONSTANTS, PAYMENT_CONSTANTS } from '../../../constants/common';
import './payoutInformation.scss';

const PayoutInformation: FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="payout-information">
      <h4 className="top-header">{LABEL_CONSTANTS.MANAGE_VENDOR_INFO}</h4>
      <div className="payout-info__header">
        <ul className="payout-info__tabs">
          <li className={activeTab === 0 ? 'active' : ''} onClick={() => setActiveTab(0)}>
            {PAYMENT_CONSTANTS.PAYOUT_HISTORY}
          </li>
          <li className={activeTab === 1 ? 'active' : ''} onClick={() => setActiveTab(1)}>
            {PAYMENT_CONSTANTS.PAYOUT_METHOD}
          </li>
        </ul>
      </div>

      <div className="payout-info__body">
        {activeTab === 0 && <PayoutPaymentHistory />}
        {activeTab === 1 && <PayoutPaymentMethod />}
      </div>
    </div>
  );
};

export default PayoutInformation;
